import React from "react"
import VerticalCenterModal from "./VerticalCenterModal"
import endpoints from '../constants/Endpoints'
import { Button } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { DateFormat } from '../utils/Utils'
import { useNavigate } from "react-router-dom"
import '../css/App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
function TrackingPage() {
    const [modalShow, setModalShow] = React.useState(false);
    const [dataTracking, setDataTracking] = React.useState({});
    const { trackingNumber } = useParams();
    const navigate = useNavigate();

    const url = endpoints.TRACKING_ORDER_BY_ID.replace(":trackingNumber", trackingNumber);
    //const url = "http://localhost:3000/api/tracking";
    const retornoPadrao = {
    id:"",
    notaFiscal:null,
    serie:null,
    chaveNfe:"",
    previsaoEntrega:"",
    cepEntrega:"",
    documentoCliente:"",
    pedido:"",
    status:"criado",
    eventos:[]
  }
  //   const retornoPadrao = {
  //     id: "HRG559ED6BE68BR",
  //     notaFiscal: 7045625,
  //     serie: 106,
  //     chaveNfe: "52240678876950012340551060070456251382149977",
  //     previsaoEntrega: "2024-06-26T03:00:00",
  //     cepEntrega: "05846050",
  //     documentoCliente: "27874791894",
  //     pedido: "v7813982hrg-01",
  //     status: "Entregue",
  //     eventos: [
  //        {
  //           transportador: "Total",
  //           imagemTransportador: "https://rastreio.ciahering.com.br/static/img/logo-total-express.png",
  //           metodoEnvio: "Serviço Normal Total v1",
  //           transportadorAuxiliar: false,
  //           historicoEventos: [
  //              {
  //                 evento: "Inicial",
  //                 dataHora: "2024-06-20T03:00:00",
  //                 detalhe: "A Entrega foi criada com sucesso. Aguarde os demais status de rastreamento"
  //              },
  //              {
  //                 evento: "Em Transito",
  //                 dataHora: "2024-06-24T07:51:05",
  //                 detalhe: "ARQUIVO RECEBIDO"
  //              },
  //              {
  //                 evento: "Em Transito",
  //                 dataHora: "2024-06-27T11:59:25",
  //                 detalhe: "COLETA RECEBIDA COM NC NO CD DE"
  //              },
  //              {
  //                 evento: "Em Transito",
  //                 dataHora: "2024-06-27T11:59:25",
  //                 detalhe: "RECEBIDA E PROCESSADA NO CD - : HUB/MATRIZ"
  //              },
  //              {
  //                 evento: "Em Transito",
  //                 dataHora: "2024-06-27T11:59:25",
  //                 detalhe: "AGUARDANDO CUBAGEM"
  //              },
  //              {
  //                 evento: "Saiu para entrega",
  //                 dataHora: "2024-07-01T10:31:06",
  //                 detalhe: "PROCESSO DE ENTREGA"
  //              },
  //              {
  //                 evento: "Saiu para entrega",
  //                 dataHora: "2024-07-01T11:00:03",
  //                 detalhe: "PROCESSO DE ENTREGA"
  //              },
  //              {
  //                 evento: "Entregue",
  //                 dataHora: "2024-07-01T14:20:30",
  //                 detalhe: "ENTREGA REALIZADA"
  //              }
  //           ]
  //        },
  //        {
  //           transportador: "APK",
  //           imagemTransportador: "https://rastreio.ciahering.com.br/static/img/logo-apk.png",
  //           metodoEnvio: "Serviço Normal Total v1",
  //           transportadorAuxiliar: true,
  //           historicoEventos: [
  //              {
  //                 evento: "Em Transito",
  //                 dataHora: "2024-06-25T02:59:00",
  //                 detalhe: "EM TRANSITO"
  //              },
  //              {
  //                 evento: "Entregue pela Transportadora Auxiliar",
  //                 dataHora: "2024-06-26T17:00:00",
  //                 detalhe: "Coletado Transportadora Last Mile"
  //              }
  //           ]
  //        }
  //     ]
  //  };
   

    // React.useEffect(() =>{
    //   fetch(url)
    //     .then(Response => Response.json())
    //     .then(data => data.pedido ? setDataTracking(data) : setDataTracking(retornoPadrao))
    // }, []);

    React.useEffect(() => {
      const controller = new AbortController();
      const signal = controller.signal;
    
      const dataInicio = new Date('2024-02-11T00:00:00');
      const dataFim = new Date('2024-02-13T00:00:00');
      const dataAtual = new Date();
      const estaDentroDoIntervalo = dataAtual >= dataInicio && dataAtual <= dataFim;
    
      let timeoutId;
      if (estaDentroDoIntervalo) {
        timeoutId = setTimeout(() => {
          controller.abort();
          navigate('/maintenance');
        }, 5000);
      }
    
      fetch(url, { signal })
        .then(response => {
          clearTimeout(timeoutId);

          if(!response.ok){
            throw new Error(`Erro na resposta da API: ${response.status} ${response.statusText}`);
          }
          return response.json();
        })
        .then(data => {
          if (data.pedido) {
            const formatData = setFormatData(data);
            setDataTracking(formatData);
          } else {
            const formatData = setFormatData(retornoPadrao);
            setDataTracking(formatData);
          }
        })
        .catch(error => {
          const formatData = setFormatData(retornoPadrao);
          setDataTracking(formatData);
          if (error.message.startsWith('Erro no servidor:')) {
        console.error('[Backend]', error.message);
        // Aqui você pode setar um estado de erro específico, ex:
        // setErro('Serviço indisponível. Tente novamente mais tarde.');
      } else if (error instanceof TypeError) {
        // Falha de rede (sem conexão, DNS, CORS, etc.)
        console.error('[Rede] Falha de conexão:', error.message);
      } else {
        console.error('[Desconhecido]', error);
      }
        });
    
      return () => {
        controller.abort();
        clearTimeout(timeoutId);
      };
    }, []);

    var statusFinalizado = false;
    const statusList = [
      {
        status: 'criado',
        label: 'Criado',
        iconClass: 'pe-7s-check  '
      },
      {
        status: 'despachado',
        label: 'Despachado',
        iconClass: 'pe-7s-paper-plane'
      },
      {
        status: 'emTransito',
        label: 'Em Trânsito',
        iconClass: 'pe-7s-car'
      },
      {
        status: 'entregue',
        label: 'Entregue',
        iconClass: 'pe-7s-home'
      },
    ];

    const stepsBody = (statusAtual) => {
      let retorno = statusList.map((x) => {
        let icon = <div key={x.status} className={statusFinalizado ? "step" : "step completed"}>
                      <div className="step-icon-wrap">
                        <div className="step-icon"><i className={x.iconClass}></i></div>
                      </div>
                      <h4 className="step-title">{x.label}</h4>
                    </div>
        if(x.status == statusAtual) {
          statusFinalizado = true;
        }
        return (
          icon
        );
      })
        
      return (
        <>{retorno}</>
      );
    }

    const statusFormat = (status) => {
      let retorno = statusList.map((x) => {
        // eslint-disable-next-line
        if(x.status == status) {
          return x.label;
        }
      });
      return retorno;
    }

    const setFormatData = (data) => {
      let eventos = data.eventos;
   
      // Array para armazenar os eventos de histórico que precisam ser realocados
      let historicoParaAdicionar = [];
   
      // Filtrar os eventos para encontrar aqueles com transportadorAuxiliar == true
      eventos = eventos.filter(evento => {
         if (evento.transportadorAuxiliar) {
            // Adiciona o historicoEventos deste evento ao array historicoParaAdicionar
            historicoParaAdicionar.push(...evento.historicoEventos);
            return false; // Remove este evento da lista de eventos
         }
         return true; // Mantém o evento na lista de eventos
      });
   
      // Adiciona os históricos encontrados ao primeiro evento não auxiliar
      if (historicoParaAdicionar.length > 0 && eventos.length > 0) {
         eventos[0].historicoEventos.push(...historicoParaAdicionar);
      }
   
      // Ordena os historicoEventos do evento principal pelo campo dataHora
      eventos.forEach(evento => {
         evento.historicoEventos.sort((a, b) => new Date(a.dataHora) - new Date(b.dataHora));
      });
   
      // Retorna o objeto atualizado
      data.eventos = eventos;
      return data;
   };

    const labelPedido = dataTracking.pedido ? "Pedido -" : "";
    const labelData = dataTracking.previsaoEntrega ? "Previsão de entrega:" : "";
    const isMarketplace = dataTracking.pedido?.startsWith('PLT');

    return (
      <div className="main_container mybackground">
    
            <h1 className="title">Rastreamento</h1>  
            
        <div className="container padding-bottom-3x mb-1">
          <div className="card mb-3">
            <div className="p-4 text-center text-white text-lg bg-dark rounded-top"><span className="text-uppercase">{labelPedido} </span><span className="text-medium">{dataTracking.pedido}</span></div>
            <div className="d-flex flex-wrap flex-sm-nowrap justify-content-between py-3 px-2 bg-secondary">
              <div className="w-100 text-center py-1 px-2 resume-text"><span className="text-medium">Status:</span> {statusFormat(dataTracking.status)}</div>
                {!isMarketplace && (
                <div className="w-100 text-center py-1 px-2 resume-text">
                  <span className="text-medium">{labelData} </span>
                  {DateFormat(dataTracking.previsaoEntrega)}
                  </div>
              )}
            </div>
            <div className="card-body">
              <div className="steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x padding-bottom-1x">
                {stepsBody(dataTracking.status)}
              </div>
            </div>
          </div>
          <div className="d-flex flex-wrap flex-md-nowrap justify-content-end align-items-center">
            <div className="text-left text-sm-right">
              <Button 
                variant="primary" 
                onClick={() => setModalShow(true)} 
                style = {{display: dataTracking.status == "criado" ? "none" : "show"}}>
                Detalhes da entrega
              </Button>
              <VerticalCenterModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                eventos = {dataTracking.eventos ?? []}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
export default TrackingPage;
